import { Box, Drawer, Grid, LinearProgress, TextField } from '@mui/material'
import { BasePathProvider } from 'components/Providers'
import SubstitutesAvailable from "./SubstitutesAvailable";
import OtherAbsentStaff from "./OtherAbsentStaff";
import SubstituteTable from "./SubstitutesTable";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { CalendarToday } from "@mui/icons-material";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getSubs, search } from "store/substitute/substitute-portal";
import { useNavigate, useParams } from 'react-router-dom'
import SubstituteFormIndex from "./Form";
import { getPeriods } from 'store/lookup'


const baseUrl = '/substitute-portal'

export default function SubstitutePortalPage() {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
    const availableSubstitutes = useSelector(state => state.substitutePortal.substitute.subs)
    const absentStaff = useSelector(state => state.substitutePortal.substitute.list)
    const periods = useSelector(state => state.lookup.periods)

    const navigate = useNavigate()
    const { id } = useParams()

    const coveragePeriods = absentStaff?.filter(s => s?.periods?.length > 0)
    const otherAbsentStaff = absentStaff?.filter(s => s?.periods?.length === 0)

    const boxStyles = {
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 2.5,
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        maxHeight: "400px",
        overflowY: "auto",
        overflowX: "auto",
    };

    const innerBoxStyles = {
        mt: 2,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
    };

    useEffect(() => {
        dispatch(getSubs({ date }));
        dispatch(search({ date }))
    }, [date, dispatch]);

    useEffect(() => {
        periods || dispatch(getPeriods())
    }, [dispatch, Boolean(periods)])

    if (!availableSubstitutes || !absentStaff) {
        return <LinearProgress />
    }


    return (
        <Box>
            <BasePathProvider value={`${baseUrl}`}>
                <Box>
                    <Grid container>
                        <Grid item md={3} xs={12}>
                            <Box sx={{ ...boxStyles, minHeight: 'none', mb: 1 }}>
                                <DatePicker
                                    label={t('Date')}
                                    defaultValue={dayjs()}
                                    onChange={date => {
                                        const formattedDate = dayjs(date)
                                        if (formattedDate.isValid()) {
                                            setDate(dayjs(date).format('YYYY-MM-DD'))
                                        }
                                    }}
                                    slots={{
                                        openPickerIcon: CalendarToday,
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            InputLabelProps: { shrink: true },
                                            InputProps: {
                                                sx: {
                                                    height: '45px',
                                                },
                                            },
                                        },
                                    }}
                                    renderInput={params => <TextField {...params} />}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} mb={1} alignItems="stretch">
                        <Grid item xs={12} display="flex">
                            <SubstituteTable 
                                coveragePeriods={coveragePeriods} 
                                date={date} 
                                boxStyles={boxStyles} 
                                innerBoxStyles={innerBoxStyles}
                                periods={periods}
                            />
                        </Grid>
                    </Grid>

                    {/* Row 3 */}
                    <Grid container spacing={1} mb={1} alignItems="stretch">
                        <Grid item xs={12} md={6} display="flex">
                            <SubstitutesAvailable 
                                availableSubstitutes={availableSubstitutes} 
                                date={date} boxStyles={boxStyles} 
                                innerBoxStyles={innerBoxStyles} 
                                periods={periods}
                                coveragePeriods={coveragePeriods}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} display="flex">
                            <OtherAbsentStaff otherAbsentStaff={otherAbsentStaff} boxStyles={boxStyles} innerBoxStyles={innerBoxStyles} />
                        </Grid>
                    </Grid>
                    <Drawer
                        PaperProps={{ sx: { width: '800px' } }}
                        anchor="right"
                        open={Boolean(id)}
                        onClose={() => navigate(baseUrl)}
                    >
                        <SubstituteFormIndex date={date} />
                    </Drawer>
                </Box>
            </BasePathProvider>
        </Box>
    )
}
